import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    eventoId: 0,
    importParticipantesId: 0,

    evento: null,
    clienteNombre: '',
    eventoNombre: '',
    camposAdicionales: [],
    participantesColumnas: [],
    importaGanadores: false,

    participantes: [],
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,

};

const mutations = {
    updateField,

    'INICIALIZAR' (state, params) {
        state.eventoId = params.eventoId;
        state.importParticipantesId = params.importParticipantesId;

        state.evento = null;
        state.clienteNombre = '';
        state.eventoNombre = '';
        state.camposAdicionales = [];
        state.participantesColumnas = [];
        state.importaGanadores = false;
    
        state.participantes = [];
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;
    },
    'SET_EVENTO' (state, evento) {
        state.evento = evento;
        state.clienteNombre = evento.cliente;
        state.eventoNombre = evento.nombre;
        state.camposAdicionales = evento.camposAdicionales;
        if (evento.participantesColumnas) {
            state.participantesColumnas = evento.participantesColumnas.sort((a, b) => {
                if (a.orden < b.orden) {
                    return -1;
                }
                if (a.orden > b.orden) {
                    return 1;
                }
                return 0;
            })
        }
        state.importaGanadores = (/true/i).test(evento.importaGanadores);
    },
    'SET_IMPORT_PARTICIPANTES' (state, importParticipantes) {
        state.participantes = importParticipantes.participantes.map(participante => ({
            ...participante,
            _rowVariant: (/true/i).test(participante.isValido) ? '' : 'danger'
        }));

        console.log(state.participantes);

        /* Agregamos la lista de campos adicionales*/
        state.participantes.forEach(participante => {
            if (participante.camposAdicionales) {
                participante.camposAdicionales.forEach(campoAdicional => {
                    participante[`cp${campoAdicional.eventoCampoAdicionalId}`] = campoAdicional.valor;
                    
                });
            }
        });

        state.totalRegistros = state.participantes.length;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', params);

            apiAxios.get(`eventos/${params.eventoId}`)
                .then(res => {
                    commit('SET_EVENTO', res.data);
                    return apiAxios.get(`eventos/${params.eventoId}/import-participantes/${params.importParticipantesId}`)
                })
                .then(res => {
                    commit('SET_IMPORT_PARTICIPANTES', res.data);    
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}